import { css } from "styled-components";
import { marginMixin } from "../marginMixin";
import { listResetMixin } from "../listResetMixin";
/** @class AccordionMixin */

/** @method */

export var AccordionMixin = function AccordionMixin(props) {
  return css(["", " ", ""], listResetMixin, marginMixin(Object.assign({}, props)));
};